import type { JSX } from 'solid-js';

/** The power glyph on Fleet Live's hide controls (prototype `ICON.off`). Decorative. */
export function FleetLivePowerIcon(): JSX.Element {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      aria-hidden="true"
    >
      <path d="M8 1.8v5.5" />
      <path d="M4.3 4a5.5 5.5 0 107.4 0" />
    </svg>
  );
}
